import { isAccelKey } from "./keyboard.mjs";
import { getPointerEventButton } from "./pointer.mjs";
function getPointerInfo(editor, e) {
  editor.markEventAsHandled(e);
  return {
    point: {
      x: e.clientX,
      y: e.clientY,
      z: e.pressure
    },
    shiftKey: e.shiftKey,
    altKey: e.altKey,
    ctrlKey: e.metaKey || e.ctrlKey,
    metaKey: e.metaKey,
    accelKey: isAccelKey(e),
    pointerId: e.pointerId,
    button: getPointerEventButton(e),
    isPen: e.pointerType === "pen"
  };
}
export {
  getPointerInfo
};
//# sourceMappingURL=getPointerInfo.mjs.map
